import React, { memo } from 'react';
import { ToolbarButtons } from './Toolbar.Styles';
import { H2, H3, H4, Citation, Ul, Ol, Code, Bold, Italic, Underline } from './Icons';
import { ToolbarButton } from './ToolbarButton';
import { RichUtils } from 'draft-js';
var BLOCK_TYPES = [
    { label: React.createElement(H2, null), style: 'header-two' },
    { label: React.createElement(H3, null), style: 'header-three' },
    { label: React.createElement(H4, null), style: 'header-four' },
    { label: React.createElement(Citation, null), style: 'blockquote' },
    { label: React.createElement(Ul, null), style: 'unordered-list-item' },
    { label: React.createElement(Ol, null), style: 'ordered-list-item' },
    { label: React.createElement(Code, null), style: 'code-block' },
];
var INLINE_STYLES = [
    { label: React.createElement(Bold, null), style: 'BOLD' },
    { label: React.createElement(Italic, null), style: 'ITALIC' },
    { label: React.createElement(Underline, null), style: 'UNDERLINE' },
];
export var BlockStyleControls = memo(function (props) {
    var editorState = props.editorState;
    var selection = editorState.getSelection();
    var blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
    var _toggle = function (blockType) {
        return props.onToggle(RichUtils.toggleBlockType(editorState, blockType));
    };
    return (React.createElement(ToolbarButtons, null, BLOCK_TYPES.map(function (type) {
        return React.createElement(ToolbarButton, { key: type.style, active: type.style === blockType, label: type.label, onToggle: _toggle, style: type.style, blockBg: props.bg });
    })));
});
export var InlineStyleControls = memo(function (props) {
    var currentStyle = props.editorState.getCurrentInlineStyle();
    var _toggle = function (inlineStyle) {
        return props.onToggle(RichUtils.toggleInlineStyle(props.editorState, inlineStyle));
    };
    return (React.createElement(ToolbarButtons, null, INLINE_STYLES.map(function (type) {
        return React.createElement(ToolbarButton, { key: type.style, active: type.style !== 'ALIGN-LEFT' ? currentStyle.has(type.style) : (!currentStyle.has('ALIGN-RIGHT') && !currentStyle.has('ALIGN-JUSTIFY') && !currentStyle.has('ALIGN-CENTER')), label: type.label, onToggle: _toggle, style: type.style, blockBg: props.bg });
    })));
});
